"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompletePasswordResetForm = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const customerAccountContext_1 = require("../../contexts/customerAccountContext");
const constants_1 = require("../../constants");
const MyAccount_1 = require("../sections/myAccount/MyAccount");
const Button_1 = require("../common/Button");
const CustomerAccount_1 = require("../CustomerAccount");
const CompletePasswordResetForm = ({ token }) => {
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const [completePasswordResetErrorMessage, setCompletePasswordResetErrorMessage] = (0, react_1.useState)();
    const { navigateTranslated } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const methods = (0, react_hook_form_1.useForm)({
        defaultValues: {
            token: token,
        },
        mode: "onBlur",
    });
    const changePassword = (formData) => {
        setCompletePasswordResetErrorMessage(undefined);
        if (token) {
            return customerAccountContext.actions.password
                .completePasswordReset(formData.email, token, formData.newPassword)
                .then(() => {
                navigateTranslated(`${CustomerAccount_1.CUSTOMER_ACCOUNT_PATH}${MyAccount_1.MY_ACCOUNT_PATH}`);
            })
                .catch((error) => {
                setCompletePasswordResetErrorMessage(t(boutik_gatsby_plugin_components_1.FormInput.FormValidation.getMagentoErrorTranslationKey(currentLocale, error.message)));
            });
        }
        else {
            return Promise.reject();
        }
    };
    return (react_1.default.createElement("div", { className: "boutik-customer-account-complete-password-reset-body" },
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("div", { className: "boutik-customer-account-complete-password-reset-body-container" },
                react_1.default.createElement("h1", { className: "boutik-customer-account-complete-password-reset-body-form-title" }, t("completePasswordReset.title")),
                react_1.default.createElement("form", { onSubmit: methods.handleSubmit(changePassword), className: "boutik-customer-account-complete-password-reset-body-form" },
                    react_1.default.createElement("input", Object.assign({ type: "hidden" }, methods.register("token", {
                        required: t("global.errors.token"),
                    }))),
                    react_1.default.createElement("div", { className: "boutik-customer-account-complete-password-reset-body-form-boxes" },
                        react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: methods, classNamePrefix: "boutik-customer-account", required: true, validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newEmailValidation(currentLocale), label: t("completePasswordReset.email"), property: "email" })),
                    react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: methods, classNamePrefix: "boutik-customer-account", label: t("completePasswordReset.newPassword"), placeholder: t("global.placeholder.minLengthPassword", { minLength: 8 }), required: true, isPassword: true, property: "newPassword", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newPasswordValidation(currentLocale) }),
                    react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: methods, classNamePrefix: "boutik-customer-account", label: t("completePasswordReset.confirmPassword"), required: true, isPassword: true, property: "confirmPassword", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.passwordConfirmationValidation(currentLocale, methods.getValues().newPassword) }),
                    react_1.default.createElement(Button_1.Button, { isLoading: methods.formState.isSubmitting, isSubmitButton: true, label: "completePasswordReset.sendBtn", classNamePrefix: "boutik-customer-account-complete-password-reset-body-form-submit" }),
                    react_1.default.createElement("p", { className: "boutik-customer-account-complete-password-reset-body-fail-message" }, completePasswordResetErrorMessage))))));
};
exports.CompletePasswordResetForm = CompletePasswordResetForm;
//# sourceMappingURL=CompletePasswordResetForm.js.map